<!--  -->
<template>
  <div class="card">
      <img class="card__img" :src="info.imageUrl" alt="">
      <!-- <div class="card__img"></div> -->
      <p class="card__text">{{info.content}}</p>
  </div>
</template>

<script>
export default {
  props: {
    info: {
        type: Object,
        default: (() => {})
    },
  },
}

</script>
<style lang='less' scoped>
.card {
  max-width: 535px;
  min-width: 346px;
  &__img {
    display: block;
    width: 100%;
    height: 346px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 12px 0px rgba(55,55,55,0.29);
    border-radius:15px;
  }
  &__text {
    width: 100%;
    text-align: left;
    // max-height: 65px;
    letter-spacing: 1px;
    font-size: 16px;
    font-family:PingFangSC-Medium;
    overflow: hidden;
    text-align: left;
  }
}
</style>